import { MapPin, Mail, Phone, Building2, FileText } from "lucide-react";
import SEO from "../components/SEO";

const TEAM = [
  { role: "Founder & CEO", name: "Alessandro Ferretti", bio: "20 anni di private equity e corporate development. Ex head of M&A in un fondo mid-market italiano. Laureato in Ingegneria Gestionale al Politecnico di Milano, MBA INSEAD." },
  { role: "Chief Investment Officer", name: "Elena Barbieri", bio: "15 anni di leveraged finance in banca d'affari. Ex direttrice del comitato crediti di un istituto italiano top-5 sul segmento PMI. Laurea in Economia alla Bocconi." },
  { role: "Chief Operating Officer", name: "Marco Zanetti", bio: "Ha guidato per 12 anni una PMI meccanica bresciana da 8M€ a 22M€ di fatturato. Conosce dall'interno il mondo che GIANO acquisisce." },
  { role: "Head of Legal & Compliance", name: "Sofia Marras", bio: "Ex partner di uno studio legale primario, specializzata in M&A del micro-mid market. Autrice del GIANO Standard Agreement." },
];

export default function ChiSiamo() {
  return (
    <main data-testid="chi-siamo-page">
      <SEO
        title="Chi Siamo — GIANO Holding S.p.A."
        description="GIANO Holding S.p.A., sede legale Milano, holding permanente italiana specializzata nell'acquisizione di PMI senza successione. Team, sede, governance, dati societari, contatti."
        path="/chi-siamo"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "mainEntity": {"@id": "https://gianoholding.com/#organization"},
          "inLanguage": "it-IT"
        }}
      />
      <section style={{ background: "var(--midnight)", color: "var(--bone)" }} className="py-24 md:py-32">
        <div className="container-x">
          <div className="overline" style={{ color: "var(--gold)" }}>Chi siamo</div>
          <h1 className="serif-display mt-6" style={{ fontSize: "clamp(44px, 6vw, 88px)", lineHeight: 1.05, maxWidth: 1100 }}>
            GIANO Holding S.p.A.<br />
            <span style={{ color: "var(--gold)", fontStyle: "italic" }}>Milano</span>, dal 2024.
          </h1>
          <p className="mt-10 text-lg md:text-xl" style={{ opacity: 0.85, maxWidth: 820, lineHeight: 1.7 }}>
            Holding permanente italiana per le PMI di nicchia senza successione. Non un fondo con exit a 5-7 anni, non un cartello di private equity. Un capitale paziente italiano che compra aziende sane e le mantiene nel gruppo — per sempre.
          </p>
        </div>
      </section>

      <section className="py-20" style={{ background: "var(--bone)" }}>
        <div className="container-x">
          <div className="overline" style={{ color: "var(--terracotta)" }}>Dati societari</div>
          <h2 className="serif-display mt-4" style={{ fontSize: "clamp(28px, 3.5vw, 40px)" }}>Trasparenza da subito</h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6">
            <Row label="Denominazione">GIANO Holding S.p.A.</Row>
            <Row label="Sede legale">Via Broletto 16 · 20121 Milano (MI)</Row>
            <Row label="P.IVA / C.F.">12345670158</Row>
            <Row label="REA Milano">MI-2765430</Row>
            <Row label="Capitale sociale">€ 12.500.000 i.v.</Row>
            <Row label="ATECO principale">64.20.10 · Attività delle società di partecipazione (holding)</Row>
            <Row label="PEC">giano-holding@legalmail.it</Row>
            <Row label="Email">info@giano.com</Row>
            <Row label="Telefono">+39 02 4700 3200</Row>
            <Row label="Iscrizione OAM">Non applicabile (holding partecipazioni, non intermediazione)</Row>
          </div>
        </div>
      </section>

      <section className="py-20" style={{ background: "var(--muted)" }}>
        <div className="container-x">
          <div className="overline" style={{ color: "var(--terracotta)" }}>Il team</div>
          <h2 className="serif-display mt-4" style={{ fontSize: "clamp(28px, 3.5vw, 40px)" }}>Chi siede al tavolo</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
            {TEAM.map(m => (
              <div key={m.name} className="card-flat p-8" data-testid={`team-${m.name.split(' ')[0]}`}>
                <div className="font-mono text-xs" style={{ color: "var(--terracotta)" }}>{m.role.toUpperCase()}</div>
                <h3 className="serif-display mt-3" style={{ fontSize: 26 }}>{m.name}</h3>
                <p className="mt-4 text-sm" style={{ opacity: 0.78, lineHeight: 1.7 }}>{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20" style={{ background: "var(--bone)" }}>
        <div className="container-x">
          <div className="overline" style={{ color: "var(--terracotta)" }}>Contatti</div>
          <h2 className="serif-display mt-4" style={{ fontSize: "clamp(28px, 3.5vw, 40px)" }}>Parliamone di persona</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
            <div><MapPin size={20} style={{ color: "var(--terracotta)" }} /><div className="mt-3 serif-display" style={{ fontSize: 22 }}>Via Broletto 16</div><div className="text-sm mt-1" style={{ opacity: 0.7 }}>20121 Milano (MI)</div></div>
            <div><Mail size={20} style={{ color: "var(--terracotta)" }} /><a href="mailto:info@giano.com" className="mt-3 block serif-display" style={{ fontSize: 22 }}>info@giano.com</a><div className="text-sm mt-1" style={{ opacity: 0.7 }}>PEC: giano-holding@legalmail.it</div></div>
            <div><Phone size={20} style={{ color: "var(--terracotta)" }} /><div className="mt-3 serif-display" style={{ fontSize: 22 }}>+39 02 4700 3200</div><div className="text-sm mt-1" style={{ opacity: 0.7 }}>Lun-Ven · 9:00-18:30</div></div>
          </div>
        </div>
      </section>
    </main>
  );
}
function Row({ label, children }) {
  return (
    <div style={{ borderBottom: "1px solid var(--border)", paddingBottom: 12 }}>
      <div className="font-mono text-xs" style={{ opacity: 0.55 }}>{label.toUpperCase()}</div>
      <div className="mt-1 text-lg" style={{ lineHeight: 1.4 }}>{children}</div>
    </div>
  );
}
